// TODO: remove code above and fix issues in case changing this file
'use strict';

(function() {
	angular.module('onboarding.common')
		.directive('cobGlobalNavigation', cobGlobalNavigation);

	cobGlobalNavigation.$inject = [
		'observerService', 'subjectObserverMessagesService', 'authenticationService', 'sessionService', 'carrierService', '$state', '$stateParams', '$window'
	];

	var observerService, subjectObserverMessagesService, observerMessages, subjectMessages, authenticationService, sessionService, carrierService, state, $stateParams, $window;

	function cobGlobalNavigation(_observerService_,
		_subjectObserverMessagesService_,
		_authenticationService_,
		_sessionService_,
		_carrierService_,
		_$state_,
		_$stateParams_,
		_$window_
	) {
		observerService = _observerService_;
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		authenticationService = _authenticationService_;
		sessionService = _sessionService_;
		carrierService = _carrierService_;
		state = _$state_;
		$stateParams = _$stateParams_;
		$window = _$window_;

		return {
			restrict: 'E',
			scope: {},
			replace: true,
			templateUrl: '/app/common/directives/cobGlobalNavigation.html',
			link: linkFunction
		};
	}

	function linkFunction(scope) {
		activate();

		function activate() {
			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();
			scope.$stateParams = $stateParams;

			scope.carrierId = $stateParams.carrierId;
			scope.brokerId = $stateParams.brokerId;
			scope.logOff = logOff;
			scope.openSettings = openSettings;
			scope.openLiveChat = openLiveChat;
			scope.returnToAdmin = returnToAdmin;
			scope.returnToAdminCarrier = returnToAdminCarrier;
			scope.getBrokerImpersonated = getBrokerImpersonated;
			scope.showCarousel = showCarousel;
			scope.getCarrierImpersonated = getCarrierImpersonated;
			scope.niceInContactEnabled = false;
			scope.accountProfileUrl = '';
			scope.openCarrierProfile = openCarrierProfile;
			scope.showProfileButton = showProfileButton;

			scope.m = {
				isBroker: sessionService.isBroker,
				isAdmin: sessionService.isAuthorizedInternalAdmin,
				isCarrier: sessionService.isCarrier
			};
			scope.truckersEdgeUrl = null;
			scope.rateViewUrl = null;
			scope.powerWebUrl = null;
			scope.directoryUrl = null;
			scope.domain = getDomain();
			scope.carrierWatchUrl = null;
			scope.firstName = '';
			scope.lastName = '';
			scope.carrierInfo = null;
			scope.truckersEdgeUrl = null;
			scope.$state = state;
			scope.stickyNav = true;
			scope.year = new Date().getFullYear();
			scope.profileButtonName = '';
			scope.loginType = '';
			getData();
			registerEventHandlers();
		}

		function registerEventHandlers() {
			observerService.registerHandlers(scope,
				[
					{ message: observerMessages.COB_OBSERVER_SESSION_RESUME, handler: getData },
					{ message: observerMessages.COB_OBSERVER_LOGIN_FINISHED_SUCCESS, handler: getData },
					{ message:observerMessages.COB_OBSERVER_LOAD_CHATSUPPORT, handler : openLiveChat },
					{ message:observerMessages.COB_OBSERVER_CARRIER_SCROLL, handler : makeNavSticky }
				]);
		}

		function getBrokerImpersonated() {
			return sessionService.getBrokerImpersonated();
		}

		function getCarrierImpersonated() {
			if (scope.m.isAdmin() && !scope.brokerId) {
				return sessionService.getCarrierImpersonated();
			}
			if (scope.carrierId && !(scope.m.isAdmin() && !scope.brokerId))
				carrierService.getCarrierDetails(scope.carrierId, scope.brokerId)
					.then(function (response) {
						if (response.data.carrierDetails.dbaName) {
							scope.carrierImpersonatedName = response.data.carrierDetails.dbaName;
						}
						else {
							scope.carrierImpersonatedName = response.data.carrierDetails.legalName;
						}
					});

			return {};
		}

		function logOff() {
			authenticationService.logout();
		}

		function openSettings() {
			observerService.sendMessageToSubject(scope,
				subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_SETTINGS_BROKER_OPEN);
		}

		function openCarrierProfile(){
			observerService.sendMessageToSubject(scope,
				subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_PROFILE_CARRIER_OPEN, scope.truckersEdgeUrl);
		}

		function openLiveChat() {
			if (!scope.niceInContactEnabled) {
				return;
			}
			openNiceinContactAgentChat();
		}

		function returnToAdmin() {
			state.go('brokersAdmin');
		}

		function returnToAdminCarrier() {
			sessionService.clearDomain();
			state.go('carriersAdmin');
		}

		function getData() {
			authenticationService.getApplicationLinks()
				.then(function(response) {
					scope.rateViewUrl = response.data.rateViewUrl;
					scope.powerWebUrl = response.data.powerWebUrl;
					scope.directoryUrl = response.data.directoryUrl;
					scope.carrierWatchUrl = response.data.carrierWatchUrl;
					scope.firstName = response.data.firstName;
					scope.lastName = response.data.lastName;
					scope.fullName = scope.firstName + ' ' + scope.lastName;
					scope.userLogin = response.data.userLogin;
					scope.userEmail = response.data.userEmail;
					scope.primaryPhone = response.data.primaryPhone;
					scope.truckersEdgeUrl = response.data.truckersEdgeUrl;
					scope.niceInContactEnabled = response.data.niceInContactEnabled;
					scope.accountProfileUrl = response.data.accountProfileUrl;
				})
				.catch(function (response) {
					if (!response) {
						return;
					}
					// Added if statemant due to errors, because this response don't have modelState field
					if (Object.prototype.hasOwnProperty.call(response.data, 'modelState')) {
						var modelErrors = response.data.modelState;
						var errors = [];
						for (var key in modelErrors) {
							for (var i = 0; i < modelErrors[key].length; i++) {
								errors.push(modelErrors[key][i]);
							}
						}
	
						observerService.sendMessageToSubject(scope,
							observerMessages.COB_SUBJECT_GENERIC_SERVER_ERROR,
							errors);
					}
				});
		}

		function makeNavSticky(data){
			scope.stickyNav = data;
		}

		function showCarousel() {
			observerService.sendMessageToSubject(scope, subjectMessages.COB_SUBJECT_CAROUSEL_REQUEST_OPEN);
		}

		function openNiceinContactAgentChat() {
			var niceInContactBaseUrl = 'https://home-c37.nice-incontact.com/inContact/ChatClient/ChatClient.aspx?poc={0}&bu={1}&P1={2}&P2={3}; {4}&P3={5}&P4={6}';
			var pointOfContact = '0893c22c-11b6-4b47-943f-649d809655d7';
			var businessUnit = '4599687';
			var niceInContactChatClient = niceInContactBaseUrl
				.replace('{0}', pointOfContact)
				.replace('{1}', businessUnit)
				.replace('{2}', scope.fullName)
				.replace('{3}', scope.userLogin)
				.replace('{4}', scope.userEmail)
				.replace('{5}', scope.primaryPhone)
				.replace('{6}', $window.location.href);

			var baseWindowOptions = 'location=no, menubar=no, status=no, resizable=no, height={0}, width={1}, top={2}, left={3}';
			var width = 410;
			var height = 700;

			var top = $window.outerHeight / 2 + $window.screenY - (height / 2);
			var left = $window.outerWidth / 2 + $window.screenX - (width / 2);

			var windowOptions = baseWindowOptions
				.replace('{0}', height)
				.replace('{1}', width)
				.replace('{2}', top)
				.replace('{3}', left);

			$window.open(niceInContactChatClient, 'niceInContactChat', windowOptions);
		}

		function isAllowedLogin(loginType) {
			var allowedLogins = sessionService.getAllowedLogins();

			return !allowedLogins ? false : allowedLogins.indexOf(loginType) !== -1;
		}

		function showProfileButton() {
			var hasBrokerBrofile = sessionService.isCarrier() && isAllowedLogin('Broker');
			var hasFreightBrokerProfile = sessionService.isCarrier() && isAllowedLogin('FreightBroker');
			var hasCarrierProfile = sessionService.isBroker() && isAllowedLogin('Carrier');

			if (hasFreightBrokerProfile) {
				scope.loginType = 'freightBroker';
				scope.profileButtonName = 'Broker';
			} else if (hasBrokerBrofile) {
				scope.loginType = 'broker';
				scope.profileButtonName = 'Broker Profile';
			} else if (hasCarrierProfile) {
				scope.loginType = 'carrier';
				scope.profileButtonName = 'Carrier Profile';
			}

			return hasBrokerBrofile || hasFreightBrokerProfile || hasCarrierProfile;
		}

		function getDomain() {
			return $('base').attr('href').split('/')[1];
		}
	}

})();
